module.exports = __webpack_public_path__ + "36ec938f82d27833aea13762a32049fd.pdf";